import pdfMake, {
  Content,
  PageOrientation,
  PageSize,
  TableCell,
  TableLayoutFunctions,
  TCreatedPdf,
  TDocumentDefinitions,
  TDocumentHeaderFooterFunction
} from 'pdfmake/build/pdfmake';
import moment from 'moment';
import {isEqual, isNaN, trim} from 'lodash';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import {AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE} from './ametras-machine-working-area-boundary.utils';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

/* tslint:disable:max-classes-per-file */

class PdfService {

  public createPdf(docDefinition: TDocumentDefinitions, tableDefinitions: {
    [name: string]: TableLayoutFunctions
  }): TCreatedPdf {
    return pdfMake.createPdf(docDefinition, tableDefinitions);
  }

}

export interface DataTableLoaderService {
  getTableData(
    field: DisguiseDto.FTFieldDto
  ): Promise<Partial<DisguiseDto.DTTemplateDto>>;
}

const convertColor = (valueColorHex: string | undefined) => {
  if (valueColorHex && valueColorHex.length === 9) {
    // alpha channel is not supported
    return valueColorHex.substring(0, 7);
  }
  return valueColorHex;
};

export class PdfTemplates {

  private static readonly CHECKBOX_POS = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>';
  private static readonly CHECKBOX_NEG = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M0 0h24v24H0z" fill="none"/></svg>';
  private static readonly POLYGON_SVG = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg version="1.2" width="4.1mm" height="4.1mm" viewBox="2457 18723 410 410" preserveAspectRatio="xMidYMid" fill-rule="evenodd" stroke-width="28.222" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" xmlns:ooo="http://xml.openoffice.org/svg/export" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:presentation="http://sun.com/xmlns/staroffice/presentation" xmlns:smil="http://www.w3.org/2001/SMIL20/" xmlns:anim="urn:oasis:names:tc:opendocument:xmlns:animation:1.0" xml:space="preserve"> <defs class="EmbeddedBulletChars">  <g id="bullet-char-template-57356" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 580,1141 L 1163,571 580,0 -4,571 580,1141 Z"/>  </g>  <g id="bullet-char-template-57354" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 8,1128 L 1137,1128 1137,0 8,0 8,1128 Z"/>  </g>  <g id="bullet-char-template-10146" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 174,0 L 602,739 174,1481 1456,739 174,0 Z M 1358,739 L 309,1346 659,739 1358,739 Z"/>  </g>  <g id="bullet-char-template-10132" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 2015,739 L 1276,0 717,0 1260,543 174,543 174,936 1260,936 717,1481 1274,1481 2015,739 Z"/>  </g>  <g id="bullet-char-template-10007" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 0,-2 C -7,14 -16,27 -25,37 L 356,567 C 262,823 215,952 215,954 215,979 228,992 255,992 264,992 276,990 289,987 310,991 331,999 354,1012 L 381,999 492,748 772,1049 836,1024 860,1049 C 881,1039 901,1025 922,1006 886,937 835,863 770,784 769,783 710,716 594,584 L 774,223 C 774,196 753,168 711,139 L 727,119 C 717,90 699,76 672,76 641,76 570,178 457,381 L 164,-76 C 142,-110 111,-127 72,-127 30,-127 9,-110 8,-76 1,-67 -2,-52 -2,-32 -2,-23 -1,-13 0,-2 Z"/>  </g>  <g id="bullet-char-template-10004" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 285,-33 C 182,-33 111,30 74,156 52,228 41,333 41,471 41,549 55,616 82,672 116,743 169,778 240,778 293,778 328,747 346,684 L 369,508 C 377,444 397,411 428,410 L 1163,1116 C 1174,1127 1196,1133 1229,1133 1271,1133 1292,1118 1292,1087 L 1292,965 C 1292,929 1282,901 1262,881 L 442,47 C 390,-6 338,-33 285,-33 Z"/>  </g>  <g id="bullet-char-template-9679" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 813,0 C 632,0 489,54 383,161 276,268 223,411 223,592 223,773 276,916 383,1023 489,1130 632,1184 813,1184 992,1184 1136,1130 1245,1023 1353,916 1407,772 1407,592 1407,412 1353,268 1245,161 1136,54 992,0 813,0 Z"/>  </g>  <g id="bullet-char-template-8226" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 346,457 C 273,457 209,483 155,535 101,586 74,649 74,723 74,796 101,859 155,911 209,963 273,989 346,989 419,989 480,963 531,910 582,859 608,796 608,723 608,648 583,586 532,535 482,483 420,457 346,457 Z"/>  </g>  <g id="bullet-char-template-8211" transform="scale(0.00048828125,-0.00048828125)">   <path d="M -4,459 L 1135,459 1135,606 -4,606 -4,459 Z"/>  </g>  <g id="bullet-char-template-61548" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 173,740 C 173,903 231,1043 346,1159 462,1274 601,1332 765,1332 928,1332 1067,1274 1183,1159 1299,1043 1357,903 1357,740 1357,577 1299,437 1183,322 1067,206 928,148 765,148 601,148 462,206 346,322 231,437 173,577 173,740 Z"/>  </g> </defs> <g class="Page">  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id3">    <rect class="BoundingBox" stroke="none" fill="none" x="2461" y="18732" width="396" height="397"/>    <path fill="rgb(254,254,254)" stroke="none" d="M 2856,18931 C 2856,18821 2767,18732 2661,18732 2550,18732 2461,18821 2461,18931 2461,19037 2550,19127 2661,19127 2767,19127 2856,19037 2856,18931 Z"/>   </g>  </g>  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id4">    <rect class="BoundingBox" stroke="none" fill="none" x="2457" y="18728" width="404" height="405"/>    <path fill="none" stroke="rgb(0,0,0)" stroke-width="8" stroke-linejoin="round" stroke-linecap="round" d="M 2856,18931 C 2856,18821 2767,18732 2661,18732 2550,18732 2461,18821 2461,18931 2461,19037 2550,19127 2661,19127 2767,19127 2856,19037 2856,18931 Z"/>   </g>  </g>  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id5">    <rect class="BoundingBox" stroke="none" fill="none" x="2516" y="18730" width="344" height="347"/>    <path fill="rgb(0,0,0)" stroke="none" d="M 2576,18750 C 2558,18758 2537,18771 2525,18784 2525,18788 2520,18788 2516,18792 2576,18792 2636,18792 2699,18792 2699,18813 2699,18881 2699,18881 2699,18881 2780,18881 2792,18881 2792,18945 2792,19012 2792,19076 2796,19076 2801,19067 2805,19063 2818,19055 2826,19042 2835,19025 2843,19008 2852,18987 2856,18966 2860,18940 2860,18915 2856,18894 2852,18868 2843,18847 2830,18830 2818,18809 2801,18788 2780,18771 2758,18758 2733,18745 2712,18736 2691,18732 2665,18728 2640,18732 2619,18732 2598,18740 2576,18750 Z"/>   </g>  </g>  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id6">    <rect class="BoundingBox" stroke="none" fill="none" x="2509" y="18723" width="358" height="361"/>    <path fill="none" stroke="rgb(0,0,0)" stroke-width="13" stroke-linejoin="round" stroke-linecap="round" d="M 2576,18750 C 2558,18758 2537,18771 2525,18784 2525,18788 2520,18788 2516,18792 L 2699,18792 2699,18881 2792,18881 2792,19076 C 2796,19076 2801,19067 2805,19063 2818,19055 2826,19042 2835,19025 2843,19008 2852,18987 2856,18966 2860,18940 2860,18915 2856,18894 2852,18868 2843,18847 2830,18830 2818,18809 2801,18788 2780,18771 2758,18758 2733,18745 2712,18736 2691,18732 2665,18728 2640,18732 2619,18732 2598,18740 2576,18750 Z"/>   </g>  </g>  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id7">    <rect class="BoundingBox" stroke="none" fill="none" x="2649" y="18928" width="24" height="29"/>    <path fill="rgb(0,0,0)" stroke="none" d="M 2665,18939 L 2660,18935 C 2656,18935 2656,18939 2656,18939 2656,18945 2656,18949 2660,18949 2660,18949 2665,18945 2665,18939 Z"/>    <path fill="none" stroke="rgb(0,0,0)" stroke-width="13" stroke-linejoin="round" stroke-linecap="round" d="M 2665,18939 L 2660,18935 C 2656,18935 2656,18939 2656,18939 2656,18945 2656,18949 2660,18949 2660,18949 2665,18945 2665,18939 Z"/>   </g>  </g> </g></svg>';
  private static readonly CIRCLE_SVG = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg version="1.2" width="4.04mm" height="4.05mm" viewBox="10580 18729 404 405" preserveAspectRatio="xMidYMid" fill-rule="evenodd" stroke-width="28.222" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" xmlns:ooo="http://xml.openoffice.org/svg/export" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:presentation="http://sun.com/xmlns/staroffice/presentation" xmlns:smil="http://www.w3.org/2001/SMIL20/" xmlns:anim="urn:oasis:names:tc:opendocument:xmlns:animation:1.0" xml:space="preserve"> <defs class="EmbeddedBulletChars">  <g id="bullet-char-template-57356" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 580,1141 L 1163,571 580,0 -4,571 580,1141 Z"/>  </g>  <g id="bullet-char-template-57354" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 8,1128 L 1137,1128 1137,0 8,0 8,1128 Z"/>  </g>  <g id="bullet-char-template-10146" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 174,0 L 602,739 174,1481 1456,739 174,0 Z M 1358,739 L 309,1346 659,739 1358,739 Z"/>  </g>  <g id="bullet-char-template-10132" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 2015,739 L 1276,0 717,0 1260,543 174,543 174,936 1260,936 717,1481 1274,1481 2015,739 Z"/>  </g>  <g id="bullet-char-template-10007" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 0,-2 C -7,14 -16,27 -25,37 L 356,567 C 262,823 215,952 215,954 215,979 228,992 255,992 264,992 276,990 289,987 310,991 331,999 354,1012 L 381,999 492,748 772,1049 836,1024 860,1049 C 881,1039 901,1025 922,1006 886,937 835,863 770,784 769,783 710,716 594,584 L 774,223 C 774,196 753,168 711,139 L 727,119 C 717,90 699,76 672,76 641,76 570,178 457,381 L 164,-76 C 142,-110 111,-127 72,-127 30,-127 9,-110 8,-76 1,-67 -2,-52 -2,-32 -2,-23 -1,-13 0,-2 Z"/>  </g>  <g id="bullet-char-template-10004" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 285,-33 C 182,-33 111,30 74,156 52,228 41,333 41,471 41,549 55,616 82,672 116,743 169,778 240,778 293,778 328,747 346,684 L 369,508 C 377,444 397,411 428,410 L 1163,1116 C 1174,1127 1196,1133 1229,1133 1271,1133 1292,1118 1292,1087 L 1292,965 C 1292,929 1282,901 1262,881 L 442,47 C 390,-6 338,-33 285,-33 Z"/>  </g>  <g id="bullet-char-template-9679" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 813,0 C 632,0 489,54 383,161 276,268 223,411 223,592 223,773 276,916 383,1023 489,1130 632,1184 813,1184 992,1184 1136,1130 1245,1023 1353,916 1407,772 1407,592 1407,412 1353,268 1245,161 1136,54 992,0 813,0 Z"/>  </g>  <g id="bullet-char-template-8226" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 346,457 C 273,457 209,483 155,535 101,586 74,649 74,723 74,796 101,859 155,911 209,963 273,989 346,989 419,989 480,963 531,910 582,859 608,796 608,723 608,648 583,586 532,535 482,483 420,457 346,457 Z"/>  </g>  <g id="bullet-char-template-8211" transform="scale(0.00048828125,-0.00048828125)">   <path d="M -4,459 L 1135,459 1135,606 -4,606 -4,459 Z"/>  </g>  <g id="bullet-char-template-61548" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 173,740 C 173,903 231,1043 346,1159 462,1274 601,1332 765,1332 928,1332 1067,1274 1183,1159 1299,1043 1357,903 1357,740 1357,577 1299,437 1183,322 1067,206 928,148 765,148 601,148 462,206 346,322 231,437 173,577 173,740 Z"/>  </g> </defs> <g class="Page">  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id3">    <rect class="BoundingBox" stroke="none" fill="none" x="10584" y="18733" width="396" height="397"/>    <path fill="rgb(255,255,255)" stroke="none" d="M 10979,18928 C 10979,18822 10894,18733 10783,18733 10673,18733 10584,18822 10584,18928 10584,19038 10673,19128 10783,19128 10894,19128 10979,19038 10979,18928 Z"/>   </g>  </g>  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id4">    <rect class="BoundingBox" stroke="none" fill="none" x="10580" y="18729" width="404" height="405"/>    <path fill="none" stroke="rgb(0,0,0)" stroke-width="8" stroke-linejoin="round" stroke-linecap="round" d="M 10979,18928 C 10979,18822 10894,18733 10783,18733 10673,18733 10584,18822 10584,18928 10584,19038 10673,19128 10783,19128 10894,19128 10979,19038 10979,18928 Z"/>   </g>  </g>  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id5">    <rect class="BoundingBox" stroke="none" fill="none" x="10755" y="18908" width="54" height="50"/>    <path fill="rgb(0,0,0)" stroke="none" d="M 10801,18933 C 10801,18924 10792,18915 10784,18915 10770,18915 10762,18924 10762,18933 10762,18941 10770,18950 10784,18950 10792,18950 10801,18941 10801,18933 Z"/>    <path fill="none" stroke="rgb(0,0,0)" stroke-width="13" stroke-linejoin="round" stroke-linecap="round" d="M 10801,18933 C 10801,18924 10792,18915 10784,18915 10770,18915 10762,18924 10762,18933 10762,18941 10770,18950 10784,18950 10792,18950 10801,18941 10801,18933 Z"/>   </g>  </g>  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id6">    <rect class="BoundingBox" stroke="none" fill="none" x="10661" y="18764" width="245" height="139"/>    <path fill="rgb(0,0,0)" stroke="none" d="M 10821,18895 C 10817,18891 10812,18886 10804,18882 10804,18878 10795,18878 10791,18874 10787,18874 10783,18874 10779,18874 10770,18874 10766,18878 10757,18882 10753,18886 10749,18891 10745,18895 10719,18874 10694,18847 10668,18822 10681,18809 10690,18801 10702,18792 10711,18788 10724,18784 10732,18780 10745,18775 10749,18771 10762,18771 10774,18771 10795,18771 10808,18771 10817,18775 10825,18775 10835,18780 10847,18784 10856,18788 10864,18792 10873,18801 10885,18809 10898,18822 10873,18847 10847,18869 10821,18895 Z"/>    <path fill="none" stroke="rgb(0,0,0)" stroke-width="13" stroke-linejoin="round" stroke-linecap="round" d="M 10821,18895 C 10817,18891 10812,18886 10804,18882 10804,18878 10795,18878 10791,18874 L 10779,18874 C 10770,18874 10766,18878 10757,18882 10753,18886 10749,18891 10745,18895 10719,18874 10694,18847 10668,18822 10681,18809 10690,18801 10702,18792 10711,18788 10724,18784 10732,18780 10745,18775 10749,18771 10762,18771 L 10808,18771 C 10817,18775 10825,18775 10835,18780 10847,18784 10856,18788 10864,18792 10873,18801 10885,18809 10898,18822 10873,18847 10847,18869 10821,18895 Z"/>   </g>  </g> </g></svg>';
  private static readonly SQUARE_SVG = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg version="1.2" width="4.04mm" height="4.05mm" viewBox="14644 18729 404 405" preserveAspectRatio="xMidYMid" fill-rule="evenodd" stroke-width="28.222" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" xmlns:ooo="http://xml.openoffice.org/svg/export" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:presentation="http://sun.com/xmlns/staroffice/presentation" xmlns:smil="http://www.w3.org/2001/SMIL20/" xmlns:anim="urn:oasis:names:tc:opendocument:xmlns:animation:1.0" xml:space="preserve"> <defs class="EmbeddedBulletChars">  <g id="bullet-char-template-57356" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 580,1141 L 1163,571 580,0 -4,571 580,1141 Z"/>  </g>  <g id="bullet-char-template-57354" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 8,1128 L 1137,1128 1137,0 8,0 8,1128 Z"/>  </g>  <g id="bullet-char-template-10146" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 174,0 L 602,739 174,1481 1456,739 174,0 Z M 1358,739 L 309,1346 659,739 1358,739 Z"/>  </g>  <g id="bullet-char-template-10132" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 2015,739 L 1276,0 717,0 1260,543 174,543 174,936 1260,936 717,1481 1274,1481 2015,739 Z"/>  </g>  <g id="bullet-char-template-10007" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 0,-2 C -7,14 -16,27 -25,37 L 356,567 C 262,823 215,952 215,954 215,979 228,992 255,992 264,992 276,990 289,987 310,991 331,999 354,1012 L 381,999 492,748 772,1049 836,1024 860,1049 C 881,1039 901,1025 922,1006 886,937 835,863 770,784 769,783 710,716 594,584 L 774,223 C 774,196 753,168 711,139 L 727,119 C 717,90 699,76 672,76 641,76 570,178 457,381 L 164,-76 C 142,-110 111,-127 72,-127 30,-127 9,-110 8,-76 1,-67 -2,-52 -2,-32 -2,-23 -1,-13 0,-2 Z"/>  </g>  <g id="bullet-char-template-10004" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 285,-33 C 182,-33 111,30 74,156 52,228 41,333 41,471 41,549 55,616 82,672 116,743 169,778 240,778 293,778 328,747 346,684 L 369,508 C 377,444 397,411 428,410 L 1163,1116 C 1174,1127 1196,1133 1229,1133 1271,1133 1292,1118 1292,1087 L 1292,965 C 1292,929 1282,901 1262,881 L 442,47 C 390,-6 338,-33 285,-33 Z"/>  </g>  <g id="bullet-char-template-9679" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 813,0 C 632,0 489,54 383,161 276,268 223,411 223,592 223,773 276,916 383,1023 489,1130 632,1184 813,1184 992,1184 1136,1130 1245,1023 1353,916 1407,772 1407,592 1407,412 1353,268 1245,161 1136,54 992,0 813,0 Z"/>  </g>  <g id="bullet-char-template-8226" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 346,457 C 273,457 209,483 155,535 101,586 74,649 74,723 74,796 101,859 155,911 209,963 273,989 346,989 419,989 480,963 531,910 582,859 608,796 608,723 608,648 583,586 532,535 482,483 420,457 346,457 Z"/>  </g>  <g id="bullet-char-template-8211" transform="scale(0.00048828125,-0.00048828125)">   <path d="M -4,459 L 1135,459 1135,606 -4,606 -4,459 Z"/>  </g>  <g id="bullet-char-template-61548" transform="scale(0.00048828125,-0.00048828125)">   <path d="M 173,740 C 173,903 231,1043 346,1159 462,1274 601,1332 765,1332 928,1332 1067,1274 1183,1159 1299,1043 1357,903 1357,740 1357,577 1299,437 1183,322 1067,206 928,148 765,148 601,148 462,206 346,322 231,437 173,577 173,740 Z"/>  </g> </defs> <g class="Page">  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id3">    <rect class="BoundingBox" stroke="none" fill="none" x="14648" y="18733" width="396" height="397"/>    <path fill="rgb(254,254,254)" stroke="none" d="M 15043,18932 C 15043,18822 14954,18733 14848,18733 14737,18733 14648,18822 14648,18932 14648,19038 14737,19128 14848,19128 14954,19128 15043,19038 15043,18932 Z"/>   </g>  </g>  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id4">    <rect class="BoundingBox" stroke="none" fill="none" x="14644" y="18729" width="404" height="405"/>    <path fill="none" stroke="rgb(0,0,0)" stroke-width="8" stroke-linejoin="round" stroke-linecap="round" d="M 15043,18932 C 15043,18822 14954,18733 14848,18733 14737,18733 14648,18822 14648,18932 14648,19038 14737,19128 14848,19128 14954,19128 15043,19038 15043,18932 Z"/>   </g>  </g>  <g class="com.sun.star.drawing.ClosedBezierShape">   <g id="id5">    <rect class="BoundingBox" stroke="none" fill="none" x="14836" y="18929" width="24" height="29"/>    <path fill="rgb(0,0,0)" stroke="none" d="M 14852,18940 L 14848,18936 C 14843,18936 14843,18940 14843,18940 14843,18946 14843,18950 14848,18950 14848,18950 14852,18946 14852,18940 Z"/>    <path fill="none" stroke="rgb(0,0,0)" stroke-width="13" stroke-linejoin="round" stroke-linecap="round" d="M 14852,18940 L 14848,18936 C 14843,18936 14843,18940 14843,18940 14843,18946 14843,18950 14848,18950 14848,18950 14852,18946 14852,18940 Z"/>   </g>  </g>  <g class="com.sun.star.drawing.PolyPolygonShape">   <g id="id6">    <rect class="BoundingBox" stroke="none" fill="none" x="14758" y="18771" width="180" height="99"/>    <path fill="rgb(0,0,0)" stroke="none" d="M 14758,18771 L 14937,18771 14937,18869 14758,18869 14758,18771 Z"/>   </g>  </g>  <g class="com.sun.star.drawing.PolyPolygonShape">   <g id="id7">    <rect class="BoundingBox" stroke="none" fill="none" x="14751" y="18768" width="189" height="109"/>    <path fill="none" stroke="rgb(0,0,0)" stroke-width="13" stroke-linejoin="round" stroke-linecap="round" d="M 14758,18869 L 14932,18869 14932,18775 14758,18775 14758,18869 Z"/>   </g>  </g> </g></svg>';

  constructor(private readonly defaultFontSize: number = 9) {
  }


  createTextField(label: string | undefined,
                  value: string | undefined,
                  alignment: 'center' | 'left' | 'right' = 'left',
                  width?: string | number,
                  fontSize: number = this.defaultFontSize,
                  cellBorder: boolean = true,
                  valueFontSize?: number,
                  valueBold?: boolean,
                  valueItalic?: boolean,
                  valueColorHex?: string,
                  labelFontSize?: number,
                  labelBold?: boolean,
                  labelItalic?: boolean,
                  labelColorHex?: string,
  ): Content {
    const labelCellContentWithBorderBelow: any[] = [];
    if (trim(label) !== '') {
      labelCellContentWithBorderBelow.push({
        fontSize: labelFontSize,
        bold: labelBold,
        italics: labelItalic,
        color: convertColor(labelColorHex),
        text: label + ':',
        border: [false, false, false, cellBorder],
        noWrap: true,
        preserveLeadingSpaces: true
      });
    }

    const labelCellContentWithoutBorderBelow: any[] = [];
    if (trim(label) !== '') {
      labelCellContentWithoutBorderBelow.push({
        fontSize: labelFontSize,
        bold: labelBold,
        italics: labelItalic,
        color: convertColor(labelColorHex),
        text: label + ':',
        border: [false, false, false, false],
        noWrap: true,
        preserveLeadingSpaces: true
      });
    }

    let body: Array<Content[] | TableCell[]> = [
      new Array<TableCell>().concat(labelCellContentWithBorderBelow)
    ];

    if (value && value.length > 100) {
      // move to next line
      body = [
        new Array<TableCell>().concat(labelCellContentWithoutBorderBelow),
        [{
          fontSize: valueFontSize,
          bold: valueBold,
          italics: valueItalic,
          color: convertColor(valueColorHex),
          text: value || '',
          // @ts-ignore
          width: '*',
          border: [false, false, false, cellBorder],
          alignment,
          preserveLeadingSpaces: true
        }]
      ];
    } else if (value !== '') {
      body = [
        new Array<TableCell | Content>().concat(labelCellContentWithBorderBelow).concat([{
          fontSize: valueFontSize,
          bold: valueBold,
          italics: valueItalic,
          color: convertColor(valueColorHex),
          text: value || '',
          // @ts-ignore
          width: '*',
          border: [false, false, false, cellBorder],
          alignment,
          preserveLeadingSpaces: true
        }])
      ];
    } else {
      body = [
        new Array<TableCell | Content>().concat(labelCellContentWithBorderBelow)
      ];
    }

    return {
      fontSize: fontSize || this.defaultFontSize,
      width: width || '100%',
      layout: 'minimalPaddings',
      table: {
        widths: (() => {
          let widths = ['auto'];
          if (body[0].length > 1) {
            widths.push('*');
          } else if (body[0].length === 1) {
            widths = ['*'];
          }
          return widths;
        })(),
        body
      }
    };
  }

  createMultilineTextField(label: string | undefined,
                           value: string | undefined,
                           alignment: 'center' | 'left' | 'right' = 'left',
                           width?: string | number,
                           fontSize: number = this.defaultFontSize,
                           cellBorder: boolean = true,
                           valueFontSize?: number,
                           valueBold?: boolean,
                           valueItalic?: boolean,
                           valueColorHex?: string,
                           labelFontSize?: number,
                           labelBold?: boolean,
                           labelItalic?: boolean,
                           labelColorHex?: string,
  ): Content {
    const labelCellContentWithBorderBelow: Content[] = [];
    const labelCellContentWithoutBorderBelow: Content[] = [];
    const body: Array<Content[] | TableCell[]> = [];
    if (trim(label) !== '') {
      labelCellContentWithBorderBelow.push({
        fontSize: labelFontSize,
        bold: labelBold,
        italics: labelItalic,
        color: convertColor(labelColorHex),
        text: label + ': ',
        border: [false, false, false, cellBorder]
      });
      labelCellContentWithoutBorderBelow.push({
        fontSize: labelFontSize,
        bold: labelBold,
        italics: labelItalic,
        color: convertColor(labelColorHex),
        text: label + ': ',
        border: [false, false, false, false]
      });
      if (value) {
        body.push(labelCellContentWithoutBorderBelow);
      } else {
        body.push(labelCellContentWithBorderBelow);
      }
    }

    if (value) {
      body.push([{
        fontSize: valueFontSize,
        bold: valueBold,
        italics: valueItalic,
        color: convertColor(valueColorHex),
        text: value,
        // @ts-ignore
        width: '*',
        border: [false, false, false, cellBorder],
        alignment
      }]);
    }

    return {
      fontSize: fontSize || this.defaultFontSize,
      width: width || '100%',
      layout: 'minimalPaddings',
      table: {
        widths: (() => {
          const widths = ['*'];
          if (body[0].length > 1) {
            widths.push('*');
          }
          return widths;
        })(),
        body
      }
    };
  }

  createDateField(
    label: string | undefined,
    value: string | undefined,
    alignment: 'center' | 'left' | 'right' = 'left',
    width?: string | number,
    fontSize?: number,
    cellBorder: boolean = true,
    valueFontSize?: number,
    valueBold?: boolean,
    valueItalic?: boolean,
    valueColorHex?: string,
    labelFontSize?: number,
    labelBold?: boolean,
    labelItalic?: boolean,
    labelColorHex?: string
  ): Content {
    let convertedValue = '';
    if (value) {
      convertedValue = moment(value).format('DD.MM.YYYY');
    }
    return this.createTextField(
      label,
      convertedValue,
      alignment,
      width,
      fontSize,
      cellBorder,
      valueFontSize,
      valueBold,
      valueItalic,
      valueColorHex,
      labelFontSize,
      labelBold,
      labelItalic,
      labelColorHex
    );
  }

  createYearMonthField(
    label: string | undefined,
    value: string | undefined,
    alignment: 'center' | 'left' | 'right' = 'left',
    width?: string | number,
    fontSize?: number,
    cellBorder: boolean = true,
    valueFontSize?: number,
    valueBold?: boolean,
    valueItalic?: boolean,
    valueColorHex?: string,
    labelFontSize?: number,
    labelBold?: boolean,
    labelItalic?: boolean,
    labelColorHex?: string,
  ): Content {
    let convertedValue = '';
    if (value) {
      convertedValue = moment(value).format('MM.YYYY');
    }
    return this.createTextField(
      label,
      convertedValue,
      alignment,
      width,
      fontSize,
      cellBorder,
      valueFontSize,
      valueBold,
      valueItalic,
      valueColorHex,
      labelFontSize,
      labelBold,
      labelItalic,
      labelColorHex
    );
  }

  createDateTimeField(label: string | undefined,
                      value: string | undefined,
                      alignment: 'center' | 'left' | 'right' = 'left',
                      width?: string | number,
                      fontSize?: number,
                      cellBorder: boolean = true): Content {
    let convertedValue = '';
    if (value) {
      convertedValue = moment(value).format('DD.MM.YYYY HH:mm');
    }

    return this.createTextField(label, convertedValue, alignment, width, fontSize, cellBorder);
  }

  createMachineWorkingAreaBoundaryField(
    value?: DisguiseDto.MachineWorkingAreaBoundaryValueDto,
    width?: string | number,
    fontSize?: number,
    cellBorder: boolean = true
  ) {
    const sizeInPdf = 300;
    const renderingSize = sizeInPdf * 4;
    const htmlCanvasElement = document.createElement('canvas');
    htmlCanvasElement.width = renderingSize;
    htmlCanvasElement.height = renderingSize;
    const ctx = htmlCanvasElement.getContext('2d');

    const defaultConfig = AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.getDefaultConfig();
    const polygonSegmentsOrDefault = (value || {}).polygonSegments || (defaultConfig || {}).polygonSegments || [];
    const polygonSegmentSplitIdx = Math.ceil(polygonSegmentsOrDefault.length / 2);
    const circleSegmentsOrDefault = (value || {}).circleSegments || (defaultConfig || {}).circleSegments || [];
    const squareSegmentsOrDefault = (value || {}).squareSegments || (defaultConfig || {}).squareSegments || [];
    const maxDistanceOrDefault = (value || {}).maxDistance || (defaultConfig || {}).maxDistance || 0;

    if (ctx !== null) {
      const multiplierForLinesWidth = 2;
      AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.drawCoords(
        ctx,
        renderingSize,
        maxDistanceOrDefault,
        AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.getMultipliedCoordsStyleConfig(multiplierForLinesWidth)
      );
      const styleConfigForContents = AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.getMultipliedStyleConfig(multiplierForLinesWidth);
      AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.drawPolygons(
        ctx,
        polygonSegmentsOrDefault,
        renderingSize,
        maxDistanceOrDefault,
        styleConfigForContents
      );
      AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.drawCircleSegments(
        ctx,
        circleSegmentsOrDefault,
        renderingSize,
        maxDistanceOrDefault,
        styleConfigForContents
      );
      AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.drawSquare(
        ctx,
        squareSegmentsOrDefault,
        renderingSize,
        maxDistanceOrDefault,
        styleConfigForContents
      );
    }

    const boundaryImageCell: TableCell = {
      fillColor: '#ffffff',
      // @ts-ignore
      width: '*',
      border: [false, false, false, false],
      image: htmlCanvasElement.toDataURL(),
      fit: [sizeInPdf, sizeInPdf],
      alignment: 'center'
    };

    const body: Content[][] | TableCell[][] = [];
    body.push([
      boundaryImageCell
    ]);

    const content: Content = {
      border: [false, false, false, false],
      width: '100%',
      layout: {
        fillColor: (rowIdx: number, node: any) => {
          let result: string;
          if (rowIdx === 0) {
            result = '#e0e0e0';
          } else {
            result = '#ffffff';
          }
          return result;
        },
        paddingLeft: (i: number, node: any) => {
          return 2;
        },
        paddingRight: (i: number, node: any) => {
          return 2;
        },
        paddingTop: (i: number, node: any) => {
          return 1;
        },
        paddingBottom: (i: number, node: any) => {
          return 1;
        },
      },
      fontSize: fontSize || this.defaultFontSize,
      table: {
        widths: ['50%', '25%', '25%'],
        body: [
          [
            {
              layout: 'minimalPaddings',
              fontSize: fontSize || this.defaultFontSize,
              table: {
                widths: ['auto', '*'],
                body: [[
                  {
                    fit: [fontSize || this.defaultFontSize, fontSize || this.defaultFontSize],
                    border: [false, false, false, false],
                    svg: PdfTemplates.POLYGON_SVG
                  },
                  {
                    text: 'Polygonzug',
                    preserveLeadingSpaces: true,
                    border: [false, false, false, false],
                  }
                ]]
              }
            },
            {
              layout: 'minimalPaddings',
              fontSize: fontSize || this.defaultFontSize,
              table: {
                widths: ['auto', '*'],
                body: [[
                  {
                    fit: [fontSize || this.defaultFontSize, fontSize || this.defaultFontSize],
                    border: [false, false, false, false],
                    svg: PdfTemplates.CIRCLE_SVG
                  },
                  {
                    text: 'Kreissegment',
                    preserveLeadingSpaces: true,
                    border: [false, false, false, false],
                  }
                ]]
              }
            },
            {
              layout: 'minimalPaddings',
              fontSize: fontSize || this.defaultFontSize,
              table: {
                widths: ['auto', '*'],
                body: [[
                  {
                    fit: [fontSize || this.defaultFontSize, fontSize || this.defaultFontSize],
                    border: [false, false, false, false],
                    svg: PdfTemplates.SQUARE_SVG
                  },
                  {
                    text: 'Viereck',
                    preserveLeadingSpaces: true,
                    border: [false, false, false, false],
                  }
                ]]
              }
            }
          ],
          [
            {
              layout: 'noBordersNoPaddings',
              fontSize: fontSize || this.defaultFontSize,
              table: {
                widths: ['50%', '50%'],
                body: [[
                  this.buildPointSequenceTable(polygonSegmentsOrDefault.slice(0, polygonSegmentSplitIdx), fontSize),
                  this.buildPointSequenceTable(polygonSegmentsOrDefault.slice(polygonSegmentSplitIdx, polygonSegmentsOrDefault.length), fontSize),
                ]]
              }
            },
            {
              layout: 'noBordersNoPaddings',
              fontSize: fontSize || this.defaultFontSize,
              table: {
                widths: ['100%'],
                body: [[
                  this.buildPointSequenceTable(circleSegmentsOrDefault, fontSize),
                ]]
              }
            },
            {
              layout: 'noBordersNoPaddings',
              fontSize: fontSize || this.defaultFontSize,
              table: {
                widths: ['100%'],
                body: [[
                  this.buildPointSequenceTable(squareSegmentsOrDefault, fontSize),
                ]]
              }
            }
          ]
        ],
        headerRows: 1
      }
    };

    // @ts-ignore
    body.push([content]);

    return {
      fontSize: fontSize || this.defaultFontSize,
      width: width || '100%',
      table: {
        widths: ['*'],
        body
      }
    };
  }

  createSignatureField(
    label: string | undefined,
    value: string | undefined,
    width?: string | number,
    fontSize?: number,
    cellBorder: boolean = true,
    labelFontSize?: number,
    labelBold?: boolean,
    labelItalic?: boolean,
    labelColorHex?: string,
    drawColorHex?: string,
    drawBackgroundColorHex?: string
  ): Content {
    const signatureValueRow: TableCell = {
      fillColor: convertColor(drawBackgroundColorHex || '#e5e5e5'),
      // @ts-ignore
      width: '*',
      border: [false, false, false, cellBorder],
      image: (value && value.split('|')[0]) ? value.split('|')[0] : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
      fit: [120, 40]
    };

    const body: Content[][] | TableCell[][] = [];
    if (trim(label) !== '') {
      body.push([
        {
          fontSize: labelFontSize,
          bold: labelBold,
          italics: labelItalic,
          color: convertColor(labelColorHex),
          text: (trim(label) !== '') ? label + ': ' : '',
          preserveLeadingSpaces: true,
          border: [false, false, false, false]
        }
      ]);
    }
    if (((value || '').split('|') || [])[1] && trim(((value || '').split('|') || [])[1]) !== '') {
      body.push([
        {
          fontSize: labelFontSize,
          bold: labelBold,
          italics: labelItalic,
          color: convertColor(labelColorHex),
          text: ((value || '').split('|') || [])[1],
          preserveLeadingSpaces: true,
          border: [false, false, false, false]
        }
      ]);
    }
    body.push([
      signatureValueRow
    ]);

    return {
      fontSize: fontSize || this.defaultFontSize,
      width: width || '100%',
      table: {
        widths: ['*'],
        body
      }
    };
  }

  createCheckboxField(
    label: string | undefined,
    value: string | undefined,
    alignment: 'center' | 'left' | 'right' = 'left',
    width?: string | number,
    fontSize?: number,
    cellBorder: boolean = true,
    checkboxSize?: number,
    labelFontSize?: number,
    labelBold?: boolean,
    labelItalic?: boolean,
    labelColorHex?: string,
  ): Content {
    let checkboxSvg;
    if (String(value) === 'true') {
      checkboxSvg = PdfTemplates.CHECKBOX_POS;
    } else {
      checkboxSvg = PdfTemplates.CHECKBOX_NEG;
    }
    return {
      fontSize: fontSize || this.defaultFontSize,
      width: width || '100%',
      layout: 'minimalPaddings',
      table: {
        widths: ['auto', '*'],
        body: [
          [
            {
              fit: [checkboxSize || fontSize || this.defaultFontSize, checkboxSize || fontSize || this.defaultFontSize],
              alignment,
              border: [false, false, false, cellBorder],
              svg: checkboxSvg
            },
            {
              fontSize: labelFontSize,
              bold: labelBold,
              italics: labelItalic,
              color: convertColor(labelColorHex),
              text: label !== undefined ? label : '',
              preserveLeadingSpaces: true,
              border: [false, false, false, cellBorder]
            },
          ]
        ]
      }
    };
  }

  createCompanySelectionField(
    label: string | undefined,
    field: DisguiseDto.FTFieldDto,
    width?: string | number,
    fontSize?: number,
    cellBorder: boolean = true
  ): Content {
    const castedField = field as DisguiseDto.LegacyFTFieldDto;
    return {
      fontSize: fontSize || this.defaultFontSize,
      width: width || '100%',
      table: {
        widths: ['auto', 'auto', 'auto', 'auto', 'auto'],
        body: [
          [

            {
              text: label !== undefined ? label + ': ' : '',
              preserveLeadingSpaces: true,
              border: [false, false, false, cellBorder]
            },
            {
              text: castedField.select && castedField.select.selectValues ? castedField.select.selectValues[0] + '' : '',
              preserveLeadingSpaces: true,
              border: [false, false, false, cellBorder]
            },
            {
              fit: [fontSize || this.defaultFontSize, fontSize || this.defaultFontSize],
              alignment: 'right',
              border: [false, false, false, cellBorder],
              svg: field.value === (castedField.select && castedField.select.selectValues ? castedField.select.selectValues[0] + '' : '') ? PdfTemplates.CHECKBOX_POS : PdfTemplates.CHECKBOX_NEG
            },
            {
              text: castedField.select && castedField.select.selectValues ? castedField.select.selectValues[1] + '' : '',
              preserveLeadingSpaces: true,
              border: [false, false, false, cellBorder]
            },
            {
              fit: [fontSize || this.defaultFontSize, fontSize || this.defaultFontSize],
              alignment: 'right',
              border: [false, false, false, cellBorder],
              svg: field.value === (castedField.select && castedField.select.selectValues ? castedField.select.selectValues[1] + '' : '') ? PdfTemplates.CHECKBOX_POS : PdfTemplates.CHECKBOX_NEG
            }
          ]
        ]
      }
    };
  }

  createCompanySelectionV2Field(
    label: string | undefined,
    field: DisguiseDto.FTFieldDto,
    width?: string | number,
    fontSize?: number,
    cellBorder: boolean = true
  ): Content {
    return {
      fontSize: fontSize || this.defaultFontSize,
      width: width || '100%',
      table: {
        widths: ['auto', 'auto', 'auto', 'auto', 'auto'],
        body: [
          [

            {
              text: label !== undefined ? label + ': ' : '',
              preserveLeadingSpaces: true,
              border: [false, false, false, cellBorder]
            },
            {
              fit: [fontSize || this.defaultFontSize, fontSize || this.defaultFontSize],
              alignment: 'right',
              border: [false, false, false, cellBorder],
              svg: field.value === (field.selectValues ? field.selectValues[0].text + '' : '') ? PdfTemplates.CHECKBOX_POS : PdfTemplates.CHECKBOX_NEG
            },
            {
              text: field.selectValues ? field.selectValues[0].text + '' : '',
              preserveLeadingSpaces: true,
              border: [false, false, false, cellBorder]
            },
            {
              fit: [fontSize || this.defaultFontSize, fontSize || this.defaultFontSize],
              alignment: 'right',
              border: [false, false, false, cellBorder],
              svg: field.value === (field.selectValues ? field.selectValues[1].text + '' : '') ? PdfTemplates.CHECKBOX_POS : PdfTemplates.CHECKBOX_NEG
            },
            {
              text: field.selectValues ? field.selectValues[1].text + '' : '',
              preserveLeadingSpaces: true,
              border: [false, false, false, cellBorder]
            },
          ]
        ]
      }
    };
  }

  createCommonFooter(): TDocumentHeaderFooterFunction {
    // @ts-ignore
    return (currentPage: number, pageCount: number, pageSize: { width: number; height: number }) => {
      return [{
        layout: 'noBordersNoPaddings',
        table: {
          widths: ['*', 'auto'],
          body: [
            [{}, {
              text: `Seite ${currentPage} von ${pageCount}`,
              margin: [0, 0, 40, 0],
              fontSize: 9,
              color: '#878787',
            }]
          ]
        }
      }];
    };
  }

  createDynamicContentDocument(
    content: string | Content | Array<string | Content>,
    // @ts-ignore
    pageSize: PageSize = 'A4',
    // @ts-ignore
    pageOrientation: PageOrientation = 'portrait',
    pageFooter: TDocumentHeaderFooterFunction | Content | string = this.createCommonFooter(),
  ): TDocumentDefinitions {
    return {
      pageSize,
      pageOrientation,
      pageMargins: [0, 0, 0, 20],
      footer: pageFooter,
      content
    };
  }

  createCommonTableDefinitions(): { [name: string]: TableLayoutFunctions } {
    return {
      noBordersNoPaddings: {
        vLineWidth: () => {
          return 0;
        },
        hLineWidth: () => {
          return 0;
        },
        paddingLeft: () => {
          return 0;
        },
        paddingRight: () => {
          return 0;
        },
        paddingTop: () => {
          return 0;
        },
        paddingBottom: () => {
          return 0;
        },
      },
      minimalPaddings: {
        paddingLeft: () => {
          return 1;
        },
        paddingRight: () => {
          return 1;
        },
        paddingTop: () => {
          return 1;
        },
        paddingBottom: () => {
          return 1;
        },
      },
      noPaddings: {
        paddingLeft: () => {
          return 0;
        },
        paddingRight: () => {
          return 0;
        },
        paddingTop: () => {
          return 0;
        },
        paddingBottom: () => {
          return 0;
        },
      },
      noBordersNoPaddingsAlignVerticallyCenter: {
        vLineWidth: () => {
          return 0;
        },
        hLineWidth: () => {
          return 0;
        },
        paddingLeft: () => {
          return 0;
        },
        paddingRight: () => {
          return 0;
        },
        paddingTop: (index: number, node: any) => {
          this.applyVerticalAlignment(node, index, 'center');
          return 0;
        },
        paddingBottom: () => {
          return 0;
        },
      },
      noBordersNoPaddingsAlignVerticallyBottom: {
        vLineWidth: () => {
          return 0;
        },
        hLineWidth: () => {
          return 0;
        },
        paddingLeft: () => {
          return 0;
        },
        paddingRight: () => {
          return 0;
        },
        paddingTop: (index: number, node: any) => {
          this.applyVerticalAlignment(node, index, 'bottom');
          return 0;
        },
        paddingBottom: () => {
          return 0;
        },
      }
    };
  }

  createCommonTableHeaderColumn(
    label: string,
    fontSize: number | undefined,
    margin?: number | [number, number] | [number, number, number, number]
  ): TableCell {
    return {
      text: label || '',
      fillColor: '#878787',
      // @ts-ignore
      color: '#ffffff',
      alignment: 'center',
      fontSize: fontSize || this.defaultFontSize,
      preserveLeadingSpaces: true,
      margin
    };
  }

  createCheckboxTableCell(
    value: string | undefined,
    alignment: 'center' | 'left' | 'right' = 'left',
    fontSize?: number
  ): TableCell {
    const currentCell: TableCell = {
      // @ts-ignore
      fit: [fontSize || this.defaultFontSize, fontSize || this.defaultFontSize],
      alignment,
      svg: String(value) === 'true' ? PdfTemplates.CHECKBOX_POS : PdfTemplates.CHECKBOX_NEG
    };
    return currentCell;
  }

  createDateStringTableCell(
    value: string | undefined,
    alignment: 'center' | 'left' | 'right' = 'left',
    fontSize?: number
  ): TableCell {
    return this.createDateTableCell(value ? moment(value) : undefined, alignment, fontSize);
  }

  createDateTableCell(
    value: moment.Moment | undefined,
    alignment: 'center' | 'left' | 'right' = 'left',
    fontSize?: number
  ): TableCell {
    return {
      text: value ? value.format('DD.MM.YYYY') : '',
      // @ts-ignore
      fontSize: fontSize || this.defaultFontSize,
      alignment
    };
  }

  createYearMonthTableCell(value: moment.Moment, fontSize?: number): TableCell {
    return {
      text: moment(value).format('MM.YYYY'),
      // @ts-ignore
      fontSize: fontSize || this.defaultFontSize,
      alignment: 'center'
    };
  }

  createTextTableCell(value: string | undefined,
                      alignment: 'center' | 'left' | 'right' = 'left',
                      fontSize?: number): TableCell {
    return {
      text: value || '',
      // @ts-ignore
      fontSize: fontSize || this.defaultFontSize,
      alignment,
      preserveLeadingSpaces: true
    };
  }

  createTableWithHeadline(label: string, result: Content, fontSize?: number): Content {
    return {
      fontSize: fontSize || this.defaultFontSize,
      layout: 'noBordersNoPaddings',
      table: {
        body: [
          [{
            text: label !== undefined ? label + ': ' : '',
            preserveLeadingSpaces: true,
            margin: [2, 0, 0, 2],
          }],
          [result],
        ],
        widths: ['*']
      }
    };
  }

  findInlineHeight(cell: any, maxWidth: number) {
    if (cell._inlines && cell._inlines.length) {

      // inlines are splitted text parts, e.g. ['Monteurname: Dominik Schmidt'] will be splitted to
      //  ['Monteurname: ', 'Dominik ', 'Schmidt']
      // for each inline, we take the sum of all inline widths
      //  'Monteurname: ' width: 10
      //  'Dominik ' width: 8
      //  'Schmidt ' width: 8
      // once the maxWidth of the parent table is reached (or the line has the flag 'lineEnd'), we move to the next row
      // e.g. if maxWidth = 20, then the text is wrapped:
      //  ['Monteurname: Dominik']
      //  ['Schmidt']
      // finally the method will return the maxHeight of all rows: ['Monteurname: Dominik'] + ['Schmidt']

      let currentRowMaxHeight = 0;
      let lastHadLineEnd = false;
      let restWidth = maxWidth;
      let finalHeight = 0;
      for (const currentNode of cell._inlines) {
        restWidth = restWidth - currentNode.width;
        if (restWidth < 0 || lastHadLineEnd) {
          // we have to move to the next row.
          finalHeight = finalHeight + currentRowMaxHeight;
          currentRowMaxHeight = currentNode.height;
          restWidth = maxWidth - currentNode.width;
        } else {
          currentRowMaxHeight = Math.max(currentNode.height, currentRowMaxHeight);
        }
        lastHadLineEnd = !!currentNode.lineEnd;
      }

      finalHeight += currentRowMaxHeight; // after last iteration, write the last row height

      return finalHeight;
    } else if (cell.table) {
      let innerTableHeight: number = 0;

      for (const currentTableRow of cell.table.body) {
        let currentTableBodyMaxHeight = 0;
        for (const currentTableRowCell of currentTableRow) {
          // now the recursion begins
          // for all children, we calculate their heights
          const currentTableBodyHeight = this.findInlineHeight(currentTableRowCell, maxWidth);
          currentTableBodyMaxHeight = Math.max(currentTableBodyMaxHeight, currentTableBodyHeight);
        }

        innerTableHeight += currentTableBodyMaxHeight;
        if (cell._offsets && cell._offsets.offsets && cell._offsets.offsets.length) {
          innerTableHeight += cell._offsets.offsets[0]; // add offset (margin or other magic stuff)
        }
      }

      return innerTableHeight;
    } else if (cell._height) {
      // e.g. images having fit property
      return cell._height;
    }

    // unknown height calculation
    return 0;
  }

  applyVerticalAlignment(node: any, rowIdx: number, align: 'center' | 'bottom', manualHeights?: number[]) { // New default argument
    const allCellHeights = node.table.body[rowIdx].map(
      (innerNode: any, columnIndex: number) => {
        return this.findInlineHeight(
          innerNode,
          node.table.widths[columnIndex]._calcWidth
        );
      }
    );
    const maxRowHeight = manualHeights ? manualHeights[rowIdx] : Math.max(...allCellHeights); // handle manual height

    node.table.body[rowIdx].forEach((cell: any, cellIdx: number) => {
      if (allCellHeights[cellIdx] && maxRowHeight > allCellHeights[cellIdx]) {
        let topMargin;

        let cellAlign = align;
        if (Array.isArray(align)) {
          cellAlign = align[cellIdx];
        }

        if (cellAlign === 'bottom') {
          topMargin = maxRowHeight - allCellHeights[cellIdx];
        } else if (cellAlign === 'center') {
          topMargin = (maxRowHeight - allCellHeights[cellIdx]) / 2;
        }

        if (topMargin) {
          if (cell._margin) {
            cell._margin[1] = topMargin;
          } else {
            cell._margin = [0, topMargin, 0, 0];
          }
        }
      }
    });
  }

  private buildPointSequenceTable(
    polygons: DisguiseDto.MachineWorkingAreaBoundaryPolygonSegmentDto[] | DisguiseDto.MachineWorkingAreaBoundaryCircleSegmentDto[] | DisguiseDto.MachineWorkingAreaBoundarySquareSegmentDto[],
    fontSize?: number
  ) {
    const result = [];
    for (const currentPolygon of polygons) {
      result.push([{
        border: [false, false, false, false],
        layout: 'minimalPaddings',
        fontSize: fontSize || this.defaultFontSize,
        widths: ['auto', 'auto', 'auto'],
        table: {
          body: [
            [{
              text: currentPolygon.name,
              border: [false, false, false, false],
              noWrap: true,
            }, {
              text: currentPolygon.distance !== undefined && currentPolygon.distance !== null && currentPolygon.distance > 0 ? `${String(currentPolygon.distance).replace('.', ',')} m, ` : '.... m, ',
              border: [false, false, false, false],
              noWrap: true,
            }, {
              text: currentPolygon.angle !== undefined && currentPolygon.angle !== null && currentPolygon.angle > 0 ? `${String(currentPolygon.angle).replace('.', ',')} °` : '.... °',
              border: [false, false, false, false],
              noWrap: true,
            }]
          ]
        }
      }]);
    }

    return {
      border: [false, false, false, false],
      layout: 'noBordersNoPaddings',
      fontSize: fontSize || this.defaultFontSize,
      table: {
        widths: ['auto'],
        body: result
      }
    };
  }
}

interface CustomFieldLoader {

  [key: string]: (field: DisguiseDto.FTFieldDto, pdfTemplates: PdfTemplates) => Promise<Content>;

}

export class FtPdfmakeTransformerService {

  constructor(
    private readonly dataTableLoaderService: DataTableLoaderService,
    private readonly customFieldLoader: CustomFieldLoader,
    private readonly columnCapacity: number = 48,
    private readonly decimalSeparator: string = ',',
    private readonly numberFieldValueHiddenValues: number[] = [0],
    private readonly timeFieldHiddenValues: string[] = ['00:00', '00:00:00'],
    private readonly customPdfTemplates: PdfTemplates = new PdfTemplates(),
  ) {
  }

  public convertPartials(contents: Array<{
    formular: DisguiseDto.FTDefinitionDto,
    header?: Content[]
  }>): Promise<TCreatedPdf> {
    return new Promise<TCreatedPdf>(async (resolve) => {

      const pageBodies: Content[] = [];
      let pageSizeInitialized = false;

      let targetPrintSizeSelector: DisguiseDto.DynamicDocumentPrintSizeSelectorDto = 'XL';
      // @ts-ignore
      let targetPageSize: PageSize = 'A4'; // global
      // @ts-ignore
      let targetPageOrientation: PageOrientation = 'portrait'; // global

      for (let currentContentIdx = 0; currentContentIdx < contents.length; currentContentIdx++) {
        const currentContent = contents[currentContentIdx];
        // @ts-ignore
        let currentPageOrientation: PageOrientation = 'portrait'; // per partial

        if (currentContent.formular.printConfig !== undefined) {
          if (currentContent.formular.printConfig.printOrientation !== undefined) {
            switch (currentContent.formular.printConfig.printOrientation) {
              case 'LANDSCAPE': {
                // @ts-ignore
                currentPageOrientation = 'landscape';
                break;
              }
              default: {
                // @ts-ignore
                currentPageOrientation = 'portrait';
                break;
              }
            }
          }

          if (!pageSizeInitialized) {
            pageSizeInitialized = true;
            if (currentContent.formular.printConfig.printOrientation !== undefined) {
              switch (currentContent.formular.printConfig.printOrientation) {
                case 'LANDSCAPE': {
                  // @ts-ignore
                  targetPageOrientation = 'landscape';
                  break;
                }
                default: {
                  // @ts-ignore
                  targetPageOrientation = 'portrait';
                  break;
                }
              }
            }
            if (currentContent.formular.printConfig.printPageSize !== undefined) {
              switch (currentContent.formular.printConfig.printPageSize) {
                case 'A10': {
                  // @ts-ignore
                  targetPageSize = 'A10';
                  break;
                }
                case 'A9': {
                  // @ts-ignore
                  targetPageSize = 'A9';
                  break;
                }
                case 'A8': {
                  // @ts-ignore
                  targetPageSize = 'A8';
                  break;
                }
                case 'A7': {
                  // @ts-ignore
                  targetPageSize = 'A7';
                  break;
                }
                case 'A6': {
                  // @ts-ignore
                  targetPageSize = 'A6';
                  break;
                }
                case 'A5': {
                  // @ts-ignore
                  targetPageSize = 'A5';
                  break;
                }
                case 'A4': {
                  // @ts-ignore
                  targetPageSize = 'A4';
                  break;
                }
                case 'A3': {
                  // @ts-ignore
                  targetPageSize = 'A3';
                  break;
                }
                case 'A2': {
                  // @ts-ignore
                  targetPageSize = 'A2';
                  break;
                }
                case 'A1': {
                  // @ts-ignore
                  targetPageSize = 'A1';
                  break;
                }
                case 'A0': {
                  // @ts-ignore
                  targetPageSize = 'A0';
                  break;
                }
                default: {
                  // @ts-ignore
                  targetPageSize = 'A4';
                  break;
                }
              }
            }
            if (currentContent.formular.printConfig.printSizeSelector !== undefined) {
              targetPrintSizeSelector = currentContent.formular.printConfig.printSizeSelector;
            }
          }
        }

        const pageContent: Content[] = [];
        for (const currentFieldRow of currentContent.formular.rows || []) {
          if (currentFieldRow['@type'] === undefined || currentFieldRow['@type'] === 'FTRowDto') {
            const castedFieldRow = currentFieldRow as DisguiseDto.FTRowDto;
            if (!castedFieldRow.printOptions || !castedFieldRow.printOptions.hide) {
              const tableRow = await this.transformFTRow(castedFieldRow, targetPrintSizeSelector, true);
              pageContent.push(tableRow);
            }
          }
        }

        const pageBody: Content[][] | TableCell[][] = [];
        if (currentContent.header !== undefined) {
          // @ts-ignore
          pageBody.push(...currentContent.header);
        }
        // @ts-ignore
        pageBody.push([pageContent]);

        pageBodies.push({
          layout: 'noBordersNoPaddings',
          table: {
            widths: ['*'],
            body: pageBody,
            headerRows: currentContent.header !== undefined ? currentContent.header.length : 0,
          },
          pageOrientation: currentPageOrientation,
          pageBreak: (contents.length === currentContentIdx + 1) ? undefined : 'after'
        });
      }

      const result = this.customPdfTemplates.createDynamicContentDocument(pageBodies, targetPageSize, targetPageOrientation);

      resolve(new PdfService().createPdf(result, this.customPdfTemplates.createCommonTableDefinitions()));
    });
  }

  private async transformFTRow(
    currentRow: DisguiseDto.FTRowDto,
    printSizeSelector: DisguiseDto.DynamicDocumentPrintSizeSelectorDto,
    cellBorder: boolean = true,
    rowMargin?: number | [number, number] | [number, number, number, number]
  ) {
    let rowLayout: 'noBordersNoPaddingsAlignVerticallyBottom' | 'noBordersNoPaddingsAlignVerticallyCenter' | 'noBordersNoPaddings' = 'noBordersNoPaddings';
    if (currentRow.align) {
      switch (currentRow.align) {
        case 'CENTER': {
          rowLayout = 'noBordersNoPaddingsAlignVerticallyCenter';
          break;
        }
        case 'END': {
          rowLayout = 'noBordersNoPaddingsAlignVerticallyBottom';
          break;
        }
      }
    }

    const result: Content[] = [{
      table: {
        widths: [],
        body: [[]],
      },
      layout: rowLayout,
      margin: rowMargin !== undefined ? rowMargin : [40, 2, 40, 2]
    }];

    let currentColIndex = 0;
    let currentColCapacity = this.columnCapacity;
    let currentRowIndex = 0;

    for (const currentRowField of currentRow.fields || []) {
      let transformedEl;

      let fieldColumnWidth;
      switch (printSizeSelector) {
        case 'XL': {
          fieldColumnWidth = (currentRow.sizes || currentRowField.sizes || {}).xl
            || (currentRow.sizes || currentRowField.sizes || {}).lg
            || (currentRow.sizes || currentRowField.sizes || {}).md
            || (currentRow.sizes || currentRowField.sizes || {}).sm
            || (currentRow.sizes || currentRowField.sizes || {}).cols
            || this.columnCapacity;
          break;
        }
        case 'LG': {
          fieldColumnWidth = (currentRow.sizes || currentRowField.sizes || {}).lg
            || (currentRow.sizes || currentRowField.sizes || {}).md
            || (currentRow.sizes || currentRowField.sizes || {}).sm
            || (currentRow.sizes || currentRowField.sizes || {}).cols
            || this.columnCapacity;
          break;
        }
        case 'MD': {
          fieldColumnWidth = (currentRow.sizes || currentRowField.sizes || {}).md
            || (currentRow.sizes || currentRowField.sizes || {}).sm
            || (currentRow.sizes || currentRowField.sizes || {}).cols
            || this.columnCapacity;
          break;
        }
        case 'SM': {
          fieldColumnWidth = (currentRow.sizes || currentRowField.sizes || {}).sm
            || (currentRow.sizes || currentRowField.sizes || {}).cols
            || this.columnCapacity;
          break;
        }
        case 'XS': {
          fieldColumnWidth = (currentRow.sizes || currentRowField.sizes || {}).cols
            || this.columnCapacity;
          break;
        }
        default: {
          fieldColumnWidth = this.columnCapacity;
          break;
        }
      }

      if (currentRowField.type === 'FTFieldDto'
        // no print option configured or field is not hidden within print options
        && (!currentRowField.printOptions || currentRowField.printOptions.hide !== true)
        // field is hidden generally but print flag states false
        && (!currentRowField.hidden || (currentRowField.printOptions && currentRowField.printOptions.hide === false))) {
        transformedEl = await this.transformFTField(
          printSizeSelector,
          currentRowField,
          (fieldColumnWidth * 100 / this.columnCapacity) + '%',
          cellBorder
        );
      }

      if (transformedEl) {
        if (fieldColumnWidth <= currentColCapacity) {
          // @ts-ignore
          result[currentRowIndex].table.body[0].push(transformedEl);
          // @ts-ignore
          result[currentRowIndex].table.widths.push((fieldColumnWidth * 100 / this.columnCapacity) + '%');
          currentColIndex++;
          currentColCapacity = currentColCapacity - fieldColumnWidth;
        } else {
          result.push({
            table: {
              body: [[
                transformedEl
              ]],
              widths: [(fieldColumnWidth * 100 / this.columnCapacity) + '%']
            },
            layout: rowLayout,
            margin: rowMargin !== undefined ? rowMargin : [40, 2, 40, 2]
          });
          currentRowIndex++;
          currentColIndex = 1;
          currentColCapacity = this.columnCapacity - fieldColumnWidth;
        }
      }
    }

    // apply pageBreak to last el
    if (result.length > 0) {
      result[result.length - 1].pageBreak = (currentRow.printOptions || {}).pageBreakAfter === true ? 'after' : undefined;
    } else {
      result[0].pageBreak = (currentRow.printOptions || {}).pageBreakAfter === true ? 'after' : undefined;
    }

    return result;
  }


  private async transformFTField(
    printSizeSelector: DisguiseDto.DynamicDocumentPrintSizeSelectorDto,
    currentField: DisguiseDto.FTFieldDto,
    width: string = '100%',
    cellBorder: boolean = true
  ) {
    const label = currentField.label;
    const value = currentField.value;

    let result: Content | null = {
      text: 'not implemented'
    };

    const alignment = this.convertHorizontalAlignment(currentField.textAlign);

    if (currentField.uiType && this.customFieldLoader[currentField.uiType] !== undefined) {
      result = await this.customFieldLoader[currentField.uiType](currentField, this.customPdfTemplates);
    } else if (currentField.uiType === 'INPUT' || currentField.uiType === 'LABEL') {
      let displayValue;
      if (value && currentField.dataType === 'NUMBER') {
        const valueAsNumber = Number(value);
        if (!isNaN(valueAsNumber) && valueAsNumber !== 0) {
          displayValue = String(valueAsNumber).replace('.', this.decimalSeparator);
        } else {
          displayValue = '';
        }
      } else {
        displayValue = value;
      }
      if (currentField.printOptions && currentField.printOptions.hideIfEmptyValue === true && displayValue === '') {
        result = null;
      } else {
        result = this.customPdfTemplates.createTextField(
          label,
          displayValue,
          alignment,
          width,
          undefined,
          cellBorder,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextFieldSpecificSettings).valueFontSize,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextFieldSpecificSettings).valueBold,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextFieldSpecificSettings).valueItalic,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextFieldSpecificSettings).valueColorHex,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextFieldSpecificSettings).labelFontSize,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextFieldSpecificSettings).labelBold,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextFieldSpecificSettings).labelItalic,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextFieldSpecificSettings).labelColorHex
        );
      }
    } else if (currentField.uiType === 'TEXTAREA') {
      if (currentField.printOptions && currentField.printOptions.hideIfEmptyValue === true && value === '') {
        result = null;
      } else {
        result = this.customPdfTemplates.createMultilineTextField(
          label,
          value,
          alignment,
          width,
          undefined,
          cellBorder,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextAreaFieldSpecificSettings).valueFontSize,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextAreaFieldSpecificSettings).valueBold,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextAreaFieldSpecificSettings).valueItalic,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextAreaFieldSpecificSettings).valueColorHex,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextAreaFieldSpecificSettings).labelFontSize,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextAreaFieldSpecificSettings).labelBold,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextAreaFieldSpecificSettings).labelItalic,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.TextAreaFieldSpecificSettings).labelColorHex
        );
      }
    } else if (currentField.uiType === 'DATE') {
      if (currentField.printOptions && currentField.printOptions.hideIfEmptyValue === true && value === '') {
        result = null;
      } else {
        result = this.customPdfTemplates.createDateField(
          label,
          value,
          alignment,
          width,
          undefined,
          cellBorder,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.DateFieldSpecificSettings).valueFontSize,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.DateFieldSpecificSettings).valueBold,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.DateFieldSpecificSettings).valueItalic,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.DateFieldSpecificSettings).valueColorHex,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.DateFieldSpecificSettings).labelFontSize,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.DateFieldSpecificSettings).labelBold,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.DateFieldSpecificSettings).labelItalic,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.DateFieldSpecificSettings).labelColorHex
        );
      }
    } else if (currentField.uiType === 'YEAR_MONTH') {
      if (currentField.printOptions && currentField.printOptions.hideIfEmptyValue === true && value === '') {
        result = null;
      } else {
        result = this.customPdfTemplates.createYearMonthField(
          label,
          value,
          alignment,
          width,
          undefined,
          cellBorder,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.YearMonthFieldSpecificSettings).valueFontSize,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.YearMonthFieldSpecificSettings).valueBold,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.YearMonthFieldSpecificSettings).valueItalic,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.YearMonthFieldSpecificSettings).valueColorHex,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.YearMonthFieldSpecificSettings).labelFontSize,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.YearMonthFieldSpecificSettings).labelBold,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.YearMonthFieldSpecificSettings).labelItalic,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.YearMonthFieldSpecificSettings).labelColorHex
        );
      }
    } else if (currentField.uiType === 'DATETIME') {
      if (currentField.printOptions && currentField.printOptions.hideIfEmptyValue === true && value === '') {
        result = null;
      } else {
        result = this.customPdfTemplates.createDateTimeField(label, value, alignment, width, undefined, cellBorder);
      }
    } else if (currentField.uiType === 'SIGNATURE') {
      if (currentField.printOptions && currentField.printOptions.hideIfEmptyValue === true && value === '') {
        result = null;
      } else {
        result = this.customPdfTemplates.createSignatureField(
          label,
          value,
          width,
          undefined,
          cellBorder,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.SignatureFieldSpecificSettings).labelFontSize,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.SignatureFieldSpecificSettings).labelBold,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.SignatureFieldSpecificSettings).labelItalic,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.SignatureFieldSpecificSettings).labelColorHex,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.SignatureFieldSpecificSettings).drawColorHex,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.SignatureFieldSpecificSettings).drawBackgroundColorHex,
        );
      }
    } else if (currentField.uiType === 'CHECKBOX') {
      if (currentField.printOptions && currentField.printOptions.hideIfEmptyValue === true && value === '') {
        result = null;
      } else {
        result = this.customPdfTemplates.createCheckboxField(
          label,
          currentField.value,
          alignment,
          width,
          undefined,
          cellBorder,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.CheckboxFieldSpecificSettings).checkboxSize,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.CheckboxFieldSpecificSettings).labelFontSize,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.CheckboxFieldSpecificSettings).labelBold,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.CheckboxFieldSpecificSettings).labelItalic,
          ((currentField.typeSpecificSettings || {}) as DisguiseDto.CheckboxFieldSpecificSettings).labelColorHex,
        );
      }
    } else if (currentField.uiType === 'COMPANY_SELECTION') {
      if (currentField.printOptions && currentField.printOptions.hideIfEmptyValue === true && value === '') {
        result = null;
      } else {
        result = this.customPdfTemplates.createCompanySelectionField(label, currentField, width, undefined, cellBorder);
      }
    } else if (currentField.uiType === 'COMPANY_SELECTION_V2') {
      if (currentField.printOptions && currentField.printOptions.hideIfEmptyValue === true && value === '') {
        result = null;
      } else {
        result = this.customPdfTemplates.createCompanySelectionV2Field(label, currentField, width, undefined, cellBorder);
      }
    } else if (currentField.uiType === 'TABLE') {
      result = await this.buildTable(currentField);
    } else if (currentField.uiType === 'MACHINE_WORKING_AREA_BOUNDARY') {
      result = this.customPdfTemplates.createMachineWorkingAreaBoundaryField(value, width, undefined, cellBorder);
    } else if (currentField.uiType === 'LIST_TABLE') {
      const table = (currentField.typeSpecificSettings as DisguiseDto.TableListFieldSpecificSettings).table;
      if (table) {
        // @ts-ignore
        result = await this.buildSplittedListTable(
          table,
          printSizeSelector
        );
      }
    }

    return result;
  }

  private async buildTable(
    currentField: DisguiseDto.FTFieldDto
  ): Promise<Content> {
    return new Promise<Content>((resolve, reject) => {
      this.dataTableLoaderService.getTableData(currentField).then((tableData) => {
        const tableRows = this.transformTableRows(tableData);
        const headerCells = this.buildTableHeader(tableData);
        const tableCols = headerCells.length;
        const body = [headerCells].concat(tableRows);
        const result: Content = {
          layout: {
            fillColor: (rowIndex: number) => {
              return (rowIndex % 2 === 0) ? '#E5E5E5' : '#F1F1F1';
            },
            vLineColor: (colIndex: number) => {
              return (colIndex === 0 || colIndex >= tableCols) ? 'black' : '#ffffff';
            }
          },
          table: {
            headerRows: 1,
            body,
            widths: (() => {
              const widthList = [];

              let longestHeaderIndex = 0;
              let currentHeaderIndex = 0;
              for (const currentColumn of tableData.columns || []) {
                if (!currentColumn.hidden && !currentColumn.hiddenForPrinting) {
                  if (currentColumn.displayLength !== undefined
                    && currentColumn.displayLength > longestHeaderIndex) {
                    longestHeaderIndex = currentHeaderIndex;
                  }
                  currentHeaderIndex++;
                }
              }

              for (let i = 0; i < tableCols; i++) {
                if (i === longestHeaderIndex) {
                  widthList.push('*');
                } else {
                  widthList.push('auto');
                }
              }

              return widthList;
            })(),
          }
        };

        resolve(this.customPdfTemplates.createTableWithHeadline(currentField.label || '', result));
      }, (error) => {
        reject(error);
      });
    });
  }

  private buildTableHeader(table: Partial<DisguiseDto.DTTemplateDto>) {
    const tableHeaderCells: TableCell[] = [];
    for (const currentTableHeader of table.columns || []) {
      if (!currentTableHeader.hidden && !currentTableHeader.hiddenForPrinting) {
        tableHeaderCells.push(
          this.customPdfTemplates.createCommonTableHeaderColumn(
            currentTableHeader.headerTitleForPrinting || currentTableHeader.headerTitle || '',
            7
          )
        );
      }
    }
    return tableHeaderCells;
  }

  private transformTableRows(tableData: Partial<DisguiseDto.DTTemplateDto>) {
    const result: TableCell[][] = [];

    const fontSize = 9;

    const tableColumnIndexByFieldNames: { [fieldName: string]: DisguiseDto.DTColumnsDto } = {};
    for (const currentColumn of tableData.columns || []) {
      tableColumnIndexByFieldNames[currentColumn.key || ''] = currentColumn;
    }

    for (const currentRow of tableData.rows || []) {
      const currentResultRow: TableCell[] = [];
      if (tableData.columns) {
        for (let currentCellIndex = 0; currentCellIndex < tableData.columns.length; currentCellIndex++) {
          const currentColumn = tableData.columns[currentCellIndex];
          if (currentRow.cells && !currentColumn.hidden && !currentColumn.hiddenForPrinting) {
            const currentCell = currentRow.cells[currentCellIndex];

            let cellValue = currentCell.value;
            if (currentColumn.useOtherFieldPrintConditions) {
              let useOtherField = true;
              for (const currentOtherFieldUsageDescription of currentColumn.useOtherFieldPrintConditions || []) {
                if (currentOtherFieldUsageDescription.fieldNameToUse !== undefined) {
                  const otherField = tableColumnIndexByFieldNames[currentOtherFieldUsageDescription.fieldNameToUse];
                  if (otherField && otherField.columnIndex !== undefined) {
                    const otherFieldValue = currentRow.cells[otherField.columnIndex].value;
                    for (const currentFieldUsageCondition of currentOtherFieldUsageDescription.conditions || []) {
                      if (currentFieldUsageCondition['@type'] === 'EqualToUseOtherFieldCondition') {
                        const castedUsageDescription = currentFieldUsageCondition as DisguiseDto.EqualToUseOtherFieldCondition;
                        /* tslint:disable:triple-equals */
                        useOtherField = useOtherField && cellValue == castedUsageDescription.valueExpression;
                      } else if (currentFieldUsageCondition['@type'] === 'NotEqualToUseOtherFieldCondition') {
                        const castedUsageDescription = currentFieldUsageCondition as DisguiseDto.NotEqualToUseOtherFieldCondition;
                        /* tslint:disable:triple-equals */
                        useOtherField = useOtherField && cellValue != castedUsageDescription.valueExpression;
                      } else if (currentFieldUsageCondition['@type'] === 'OtherFieldEqualsValueUseOtherFieldCondition') {
                        const castedUsageDescription = currentFieldUsageCondition as DisguiseDto.OtherFieldEqualsValueUseOtherFieldCondition;
                        /* tslint:disable:triple-equals */
                        useOtherField = useOtherField && otherFieldValue == castedUsageDescription.valueExpression;
                      } else if (currentFieldUsageCondition['@type'] === 'OtherFieldNotEqualsValueUseOtherFieldCondition') {
                        const castedUsageDescription = currentFieldUsageCondition as DisguiseDto.OtherFieldNotEqualsValueUseOtherFieldCondition;
                        /* tslint:disable:triple-equals */
                        useOtherField = useOtherField && otherFieldValue != castedUsageDescription.valueExpression;
                      }
                      if (!useOtherField) {
                        break;
                      }
                    }
                    if (useOtherField) {
                      cellValue = otherFieldValue;
                      break;
                    }
                  }
                }
              }
            }

            if (currentColumn.dataType === 'NUMBER') {
              const valueAsNumber = Number(cellValue);
              if (!isNaN(valueAsNumber) && this.numberFieldValueHiddenValues.indexOf(valueAsNumber) < 0) {
                cellValue = String(valueAsNumber).replace('.', this.decimalSeparator);
              } else {
                cellValue = '';
              }
            }

            if (currentColumn.uiType === 'LABEL'
              || currentColumn.uiType === 'INPUT'
              || currentColumn.uiType === 'ARTICLENO'
              || currentColumn.uiType === 'SELECT') {
              currentResultRow.push(
                this.customPdfTemplates.createTextTableCell(
                  cellValue || '',
                  'left',
                  fontSize
                )
              );
            } else if (currentColumn.uiType === 'INPUT_UPPERCASE') {
              currentResultRow.push(
                this.customPdfTemplates.createTextTableCell(
                  (cellValue || '').toUpperCase(),
                  'left',
                  fontSize
                )
              );
            } else if (currentColumn.uiType === 'TIME' && cellValue) {
              let convertedCellValue;
              if (cellValue && this.timeFieldHiddenValues.indexOf(cellValue) <= 0) {
                convertedCellValue = moment(cellValue, 'HH:mm:SS').format('HH:mm');
              } else {
                convertedCellValue = '';
              }

              currentResultRow.push({
                text: convertedCellValue,
                // @ts-ignore
                fontSize,
                alignment: 'center'
              });
            } else if (currentColumn.uiType === 'CHECKBOX') {
              currentResultRow.push(
                this.customPdfTemplates.createCheckboxTableCell(String(cellValue))
              );
            } else if (currentColumn.uiType === 'SELECT_ENTITY_REF' && currentCell.id) {
              let foundId: DisguiseDto.SelectDto | undefined;
              for (const currentSelection of currentColumn.selectValues || []) {
                const currentCastedSelection =
                  currentSelection as DisguiseDto.LegacyDTSelectDto;
                if (currentCastedSelection.id !== undefined
                  && isEqual(currentCastedSelection.id, currentCell.id)) {
                  foundId = currentSelection;
                  break;
                } else if (isEqual(currentSelection.ids, currentCell.id)) {
                  foundId = currentSelection;
                  break;
                }
              }

              if (foundId) {
                currentResultRow.push({
                  text: foundId.text || '',
                  // @ts-ignore
                  fontSize
                });
              } else {
                // if noone has been found
                // this happens if a mechanic was added in the team
                // and then he is removed (e.g. because of a removal of the team assignment)
                currentResultRow.push({
                  text: '',
                  // @ts-ignore
                  fontSize
                });
              }

            } else if (currentColumn.uiType === 'DATE' && cellValue) {
              currentResultRow.push(
                this.customPdfTemplates.createDateStringTableCell(
                  cellValue,
                  'left',
                  fontSize
                )
              );
            } else {
              // @ts-ignore
              currentResultRow.push({});
            }
          }
        }
      }
      result.push(currentResultRow);
    }


    return result;
  }

  private async buildListTable(
    table: DisguiseDto.DynamicDocumentFieldTypeListTableDto | DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2,
    startSectionIndex: number,
    endSectionIndex: number,
    printSizeSelector: DisguiseDto.DynamicDocumentPrintSizeSelectorDto
  ) {
    const tableHeaderCells: TableCell[] | Content[] = [];
    let hasAtLeastOneColumnWithLabel = false;
    for (const currentColumn of table.columns || []) {
      if (currentColumn.fieldType) {
        switch (currentColumn.fieldType['@type']) {
          case 'DynamicDocumentFieldTypeMachineWorkingAreaBoundaryDtoV2':
            hasAtLeastOneColumnWithLabel = true;
            tableHeaderCells.push(this.customPdfTemplates.createCommonTableHeaderColumn('', undefined, [2, 2, 2, 2]));
            break;
          default:
            hasAtLeastOneColumnWithLabel = hasAtLeastOneColumnWithLabel || (currentColumn.fieldType.label !== undefined && currentColumn.fieldType.label !== '');
            tableHeaderCells.push(this.customPdfTemplates.createCommonTableHeaderColumn(currentColumn.fieldType.label || '', undefined, [2, 2, 2, 2]));
            break;
        }
      }
    }

    const result: Content = {
      layout: {
        fillColor: (rowIndex: number) => {
          const optionalBgEvenBgColor = (table as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2).backgroundEvenColorHex;
          const optionalBgOddBgColor = (table as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2).backgroundOddColorHex;
          return (rowIndex % 2 === 0)
            ? convertColor(optionalBgEvenBgColor || '#E5E5E5')
            : convertColor(optionalBgOddBgColor || '#F1F1F1');
        },
        vLineColor: (colIndex: number) => {
          return convertColor((table as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2).verticalLineColorHex) || (colIndex === 0 || colIndex >= (table.columns || []).length) ? 'black' : '#ffffff';
        },
        hLineColor: (colIndex: number) => {
          return convertColor((table as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2).horizontalLineColorHex) || (colIndex === 0 || colIndex >= (table.columns || []).length) ? 'black' : '#ffffff';
        },
        hLineWidth: (i: number, node: any) => {
          return (table as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2).horizontalLineWidth != undefined ? (table as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2).horizontalLineWidth : 1;
        },
        vLineWidth: (i: number, node: any) => {
          return (table as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2).verticalLineWidth != undefined ? (table as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2).verticalLineWidth : 1;
        },
        paddingLeft: () => {
          return 1;
        },
        paddingRight: () => {
          return 1;
        },
        paddingTop: () => {
          return 0;
        },
        paddingBottom: () => {
          return 0;
        }
      }
    };
    const tableRows: Array<TableCell[] | Content[]> = [];
    if (table.sections && table.columns) {
      for (let sectionIndex = startSectionIndex; sectionIndex <= endSectionIndex; sectionIndex++) {
        const currentSection = table.sections[sectionIndex];
        if (currentSection.label) {
          const sectionRow: Array<(TableCell | Content)> = [];
          sectionRow.push({
            // @ts-ignore
            text: currentSection.label || '',
            preserveLeadingSpaces: true,
            colSpan: table.columns.length,
            fillColor: convertColor((currentSection as DisguiseDto.DynamicDocumentListTableSectionDtoV2).backgroundColorHex || '#878787'),
            color: convertColor((currentSection as DisguiseDto.DynamicDocumentListTableSectionDtoV2).valueColorHex || '#ffffff'),
            bold: (currentSection as DisguiseDto.DynamicDocumentListTableSectionDtoV2).valueBold,
            italics: (currentSection as DisguiseDto.DynamicDocumentListTableSectionDtoV2).valueItalic,
            fontSize: (currentSection as DisguiseDto.DynamicDocumentListTableSectionDtoV2).valueFontSize || 9,
            margin: [3, 2, 3, 2],
          });
          for (let currentColumnIndex = 1; // start with second item
               currentColumnIndex < table.columns.length;
               currentColumnIndex++) {
            // empty column is needed for colspan
            // @ts-ignore
            sectionRow.push('');
          }
          tableRows.push(sectionRow);
        }

        if (table['@type'] !== undefined && table['@type'] === 'DynamicDocumentFieldTypeListTableDtoV2') {
          // neu
          const castedCurrentSection = currentSection as DisguiseDto.DynamicDocumentListTableSectionDtoV2;
          for (const currentSectionRow of (castedCurrentSection.rows || [])) {
            const tableSectionContent: Content[] = [];

            for (const currentSectionRowCell of (currentSectionRow.cells || [])) {
              if (currentSectionRowCell.cellFormular) {
                const rowContents = [];
                for (const currentFieldRow of currentSectionRowCell.cellFormular.rows || []) {
                  if (currentFieldRow['@type'] === 'FTRowDto') {
                    if (!currentFieldRow.printOptions || !currentFieldRow.printOptions.hide) {
                      const tableRow = await this.transformFTRow(currentFieldRow, printSizeSelector, false, [1, 0, 1, 0]);
                      rowContents.push(tableRow);
                    }
                  } else {
                    throw new Error('Unknown content');
                  }
                }

                tableSectionContent.push(rowContents);
              }
            }
            // @ts-ignore
            tableRows.push(tableSectionContent);
          }
        } else {
          // alt
          if (currentSection.rows) {
            for (const currentSectionRow of (currentSection.rows as DisguiseDto.DynamicDocumentListTableSectionRowDto[])) {
              const tableSectionContent: Content[] = [];
              if (currentSectionRow.fields) {
                for (let tableColumnIdx = 0; tableColumnIdx < table.columns.length; tableColumnIdx++) {
                  const currentTableColumn = table.columns[tableColumnIdx];
                  if (currentTableColumn.fieldType) {
                    const currentSectionField = currentSectionRow.fields[tableColumnIdx];

                    if (currentTableColumn.fieldType['@type'] === 'DynamicDocumentFieldTypeTextDto') {
                      tableSectionContent.push(this.customPdfTemplates.createTextTableCell(
                        currentSectionField.value,
                        this.convertHorizontalAlignment(currentTableColumn.fieldType.horizontalAlignment)
                      ));
                    } else if (currentTableColumn.fieldType['@type'] === 'DynamicDocumentFieldTypeCheckboxDto') {
                      tableSectionContent.push(this.customPdfTemplates.createCheckboxTableCell(
                        currentSectionField.value,
                        this.convertHorizontalAlignment(currentTableColumn.fieldType.horizontalAlignment)
                      ));
                    } else if (currentTableColumn.fieldType['@type'] === 'DynamicDocumentFieldTypeDateDto') {
                      tableSectionContent.push(this.customPdfTemplates.createDateStringTableCell(
                        currentSectionField.value,
                        this.convertHorizontalAlignment(currentTableColumn.fieldType.horizontalAlignment)
                      ));
                    } else if (currentTableColumn.fieldType['@type'] === 'DynamicDocumentFieldTypeNumberDto') {
                      let cellValue = '';
                      const valueAsNumber = Number(currentSectionField.value);
                      if (!isNaN(valueAsNumber) && this.numberFieldValueHiddenValues.indexOf(valueAsNumber) < 0) {
                        cellValue = String(valueAsNumber).replace('.', this.decimalSeparator);
                      }
                      tableSectionContent.push(this.customPdfTemplates.createTextTableCell(
                        cellValue,
                        this.convertHorizontalAlignment(currentTableColumn.fieldType.horizontalAlignment)
                      ));
                    } else if (currentTableColumn.fieldType['@type'] === 'DynamicDocumentFieldTypeSignatureDto') {
                      tableSectionContent.push(this.customPdfTemplates.createSignatureField(currentTableColumn.fieldType.label, currentSectionField.value));
                    } else {
                      tableSectionContent.push({});
                    }
                  } else {
                    tableSectionContent.push({});
                  }
                }
                // @ts-ignore
                tableRows.push(tableSectionContent);
              }
            }
          }
        }
      }
    }

    let body: Array<TableCell[] | Content[]>;
    if (hasAtLeastOneColumnWithLabel) {
      body = [
        tableHeaderCells
      ].concat(tableRows);
    } else {
      body = tableRows;
    }
    result.table = {
      dontBreakRows: true,
      headerRows: hasAtLeastOneColumnWithLabel ? 1 : 0,
      body,
      widths: (() => {
        const widthList = [];

        if (table['@type'] !== undefined && table['@type'] === 'DynamicDocumentFieldTypeListTableDtoV2') {
          for (const element of (table.columns || [])) {
            if (element.widthPercentage !== undefined && element.widthPercentage !== '') {
              widthList.push(`${element.widthPercentage}%`);
            } else {
              widthList.push('*');
            }
          }
        } else {
          for (const element of (table.columns || [])) {
            widthList.push('*');
          }
        }

        return widthList;
      })(),
    };

    return result;
  }

  private convertHorizontalAlignment(horizontalAlignment: 'LEFT' | 'CENTER' | 'RIGHT' | 'JUSTIFIED' | undefined) {
    let alignment: 'left' | 'center' | 'right' = 'left';
    if (horizontalAlignment) {
      switch (horizontalAlignment) {
        case 'LEFT': {
          alignment = 'left';
          break;
        }
        case 'CENTER': {
          alignment = 'center';
          break;
        }
        case 'RIGHT': {
          alignment = 'right';
          break;
        }
        default: {
          alignment = 'left';
          break;
        }
      }
    }
    return alignment;
  }

  private async buildSplittedListTable(
    table: DisguiseDto.DynamicDocumentFieldTypeListTableDto,
    printSizeSelector: DisguiseDto.DynamicDocumentPrintSizeSelectorDto
  ) {
    if (table.sections) {
      let split: number;
      switch (printSizeSelector) {
        case 'XL': {
          split = table.rowSplitXl || table.rowSplitLg || table.rowSplitMd || table.rowSplitSm || table.rowSplitXs || 1;
          break;
        }
        case 'LG': {
          split = table.rowSplitLg || table.rowSplitMd || table.rowSplitSm || table.rowSplitXs || 1;
          break;
        }
        case 'MD': {
          split = table.rowSplitMd || table.rowSplitSm || table.rowSplitXs || 1;
          break;
        }
        case 'SM': {
          split = table.rowSplitSm || table.rowSplitXs || 1;
          break;
        }
        case 'XS': {
          split = table.rowSplitXs || 1;
          break;
        }
        default: {
          split = 1;
          break;
        }
      }

      const splitIndices = []; // [2, 5, 10] means (0-2, 3-5, 6-10)
      if (table.sections.length < split) {
        split = table.sections.length;
      }
      if (split === table.sections.length) {
        // we have exactly <split> sections
        // each section must be mapped to its own column
        for (let idx = 0; idx < split; idx++) {
          splitIndices.push(idx);
        }
      } else {
        // we have more sections than <split>
        let overallSum = 0;
        const sectionWeights = [];
        for (let currentSectionIndex = 0; currentSectionIndex < table.sections.length; currentSectionIndex++) {
          const currentSection = table.sections[currentSectionIndex];
          const currentSectionRows = currentSection.rows || [];
          sectionWeights[currentSectionIndex] = 1 + currentSectionRows.length;
          overallSum += 1 + currentSectionRows.length;
        }

        const avgMiddle = Math.round(overallSum / split);
        let currentWeightSum = 0;
        for (let sectionWeightIndex = 0; sectionWeightIndex < sectionWeights.length; sectionWeightIndex++) {
          const currentWeight = sectionWeights[sectionWeightIndex];
          currentWeightSum += currentWeight;
          if (currentWeightSum > avgMiddle) {
            splitIndices.push(sectionWeightIndex - 1);
            currentWeightSum = 0;
          } else if (sectionWeightIndex === sectionWeights.length - 1) {
            // last item
            splitIndices.push(sectionWeightIndex);
          }
        }
      }

      const tableContents: Content[] = [];
      let start = 0;
      for (const currentSplit of splitIndices) {
        const listTable = await this.buildListTable(table, start, currentSplit, printSizeSelector);
        tableContents.push(listTable);
        start = currentSplit + 1;
      }

      const splittedtable = {
        width: '100%',
        layout: 'noBordersNoPaddings',
        table: {
          widths: (() => {
            const tableWidths = [];
            for (const item of tableContents) {
              tableWidths.push('*');
            }
            return tableWidths;
          })(),
          body: [
            tableContents
          ]
        }
      };

      return splittedtable;
    } else {
      return '';
    }
  }
}
